export default __webpack_public_path__ + "static/media/vrf3.e1942ea2.jpg";